<template>
  <div class="device-management">
    <AddDevice/>
    <div class="dashboard-container">
      <div class="manage-devices d-flex flex-column flex-sm-row align-items-center justify-content-between">
        <h2>Manage your devices</h2>
        <button class="main-btn d-block d-sm-inline-block" type="button" data-bs-toggle="modal"
                data-bs-target="#addDevice">Add Device</button>
      </div>
      <div class="devices box-style">
        <div class="device" v-for="d in devices" :key="d.id">
          <div class="device-name">
            <div class="icon" v-html="iconOS(d.os)">
            </div>
            <p>{{ formatOS(d.os) }}</p>
          </div>
          <div class="device-active">
            <p>{{ formatDateFromNow(d.online) }}</p>
          </div>
          <div class="device-type">{{ formatOS(d.os) }} {{ d.version }}</div>
          <div class="device-type">{{ d.ip }}</div>
        </div>
      <div class="text-center" v-if="devices.length === 0"><h2>No devices</h2></div>
      </div>
    </div>
  </div>
</template>

<script>
import {Device} from "@/models"
import {iconOS, formatOS, formatDateFromNow} from "@/helpers"
import AddDevice from "@/components/modals/AddDevice"

import API from "@/api"
const api = new API()

export default {
  name: "Devices",
  components: {AddDevice},
  computed: {
    devices() {
      return Device.query().orderBy('online', 'desc').get()
    }
  },
  mounted() {
    this.$wait.start('devices_fetch')
    api.getDevices()
        .then(r => Device.deleteAll().then(() => Device.insertOrUpdate({
          data: r.data.results
        })))
        .catch(e => console.log(e))
        .finally(() => this.$wait.end('devices_fetch'))
  },
  methods: {
    iconOS(name) {
      return iconOS(name)
    },
    formatOS(name) {
      return formatOS(name)
    },
    formatDateFromNow(date) {
      return formatDateFromNow(date)
    }
  }
}
</script>
